export default "__VITE_ASSET__c02e9d81__"